import { render, staticRenderFns } from "./avs.vue?vue&type=template&id=3c9e5802&"
import script from "./avs.vue?vue&type=script&lang=js&"
export * from "./avs.vue?vue&type=script&lang=js&"
import style0 from "./avs.vue?vue&type=style&index=0&id=3c9e5802&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RzContainer: require('/opt/yamal.ru/node_modules/razlet-ui/src/components/container/index.vue').default})
